import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/skillMap';

export interface ISkillMapState {
	readonly skillMapData: Actions.ISkillMapData;
	readonly detailData: Actions.IDetailData[];
	readonly historyList: Actions.ISkillMapHistory[];
}

/**
 * 初期化状態を定義する。
 */
const initialState: ISkillMapState = {
	detailData: [],
	historyList: [],
	skillMapData: {
		applyFlg: 0,
		divisionData: [],
		levelData: [],
		masterData: {
			division1Color: '',
			division2Color: '',
			division3Color: '',
			goalCompleteColor: '',
			longGoalColor: '',
			shortGoalColor: '',
		},
		rootDivision: [],
		updateInfo: {
			skillMapName: '',
			updateTime: '',
			updator: '',
		},
	},
};

/**
 * スキルマップ状態
 * @param state 状態
 * @param action 動作
 */
const skillMap = (state: ISkillMapState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}

	if (isType(action, Actions.setSkillMapData)) {
		// スキルマップデータ設定
		return {
			...state,
			skillMapData: {
				applyFlg: action.payload.applyFlg,
				divisionData: action.payload.divisionData,
				levelData: action.payload.levelData,
				masterData: action.payload.masterData,
				rootDivision: action.payload.rootDivision,
				updateInfo: action.payload.updateInfo,
			},
		};
	} else if (isType(action, Actions.setDetailData)) {
		// セル詳細データ設定
		return {
			...state,
			detailData: [...action.payload],
		};
	} else if (isType(action, Actions.setHistoryData)) {
		// 更新履歴データ設定
		return {
			...state,
			historyList: [...action.payload],
		};
	} else if (isType(action, Actions.setLastUpdateData)) {
		// 最後更新情報データ設定
		const tempData = { ...state };
		tempData.skillMapData.updateInfo.skillMapName =
			action.payload.skillMapName;
		tempData.skillMapData.updateInfo.updateTime = action.payload.updateTime;
		tempData.skillMapData.updateInfo.updator = action.payload.updator;

		return tempData;
	}

	return state;
};

export default skillMap;



// WEBPACK FOOTER //
// ./src/reducers/skillMap.ts